module.exports = __webpack_public_path__ + "static/media/wallet.01792903.svg";